import {Injectable} from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';


import {Account} from '../model/account.model';
import {environment} from '../../../../environments/environment';
import {User} from './user/user.model';
import {Router} from '@angular/router';
import {LangService} from '../../../admin/services/lang.service';

@Injectable({providedIn: 'root'})
export class AccountService {
    private userIdentity: User;
    private authenticated = false;
    private authenticationState = new BehaviorSubject<User>(null);

    constructor(
        // private languageService: JhiLanguageService,
        private http: HttpClient,
        private readonly router: Router,
        private readonly langService: LangService
    ) {
    }

    fetch(): Observable<HttpResponse<Account>> {
        return this.http.get<Account>(environment.SERVER_API_URL + 'api/account', {observe: 'response'});
    }

    getAuthenticationState(): Observable<User> {
        return this.authenticationState.asObservable();
    }

    isAuthenticated(): boolean {
        return this.authenticated;
    }

    isIdentityResolved(): boolean {
        return this.userIdentity !== undefined;
    }

    getImageUrl(): string {
        return this.isIdentityResolved() ? /*this.userIdentity.imageUrl*/ null : null;
    }

    save(account: any): Observable<HttpResponse<any>> {
        return this.http.post(environment.SERVER_API_URL + 'services/uaa/api/account', account, {observe: 'response'});
    }

    authenticate(identity) {
        this.userIdentity = identity;
        this.authenticated = identity !== null;
        this.authenticationState.next(this.userIdentity);
    }

    identity(force?: boolean): Promise<User> {
        if (force) {
            this.userIdentity = undefined;
        }

        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving
        if (this.userIdentity) {
            return Promise.resolve(this.userIdentity);
        }

        // retrieve the userIdentity data from the server, update the identity object, and then resolve.
        return this.fetch()
            .toPromise()
            .then(response => {
                console.log('GET DROIT DMP');
                const account: User = User.build(response.body);
                if (account && account.authorities.length > 0) {
                    this.userIdentity = account;
                    this.authenticated = true;
                    // this.trackerService.connect();
                    // After retrieve the account info, the language will be changed to
                    // the user's preferred language configured in the account setting
                    if (this.userIdentity.langKey) {
                        this.langService.applyUserLanguage(this.userIdentity.langKey);
                    }
                } else {
                    this.userIdentity = null;
                    this.authenticated = false;
                    // this.router.navigate(['/']);
                }
                this.authenticationState.next(this.userIdentity);
                return this.userIdentity;
            })
            .catch(err => {
                // if (this.trackerService.stompClient && this.trackerService.stompClient.connected) {
                //     this.trackerService.disconnect();
                // }
                this.userIdentity = null;
                this.authenticated = false;
                this.authenticationState.next(this.userIdentity);
                this.router.navigate(['/']);
                return null;
            });
    }

    hasAnyRule(rules: string[]): boolean {
        if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
            return false;
        }
        const rulesUser = this.userIdentity.rules.map(r => r.rule);
        return this.userIdentity.authorities.includes('SUPER_ADMIN') || rules.some((rule: string) => rulesUser.includes(rule));
    }

    hasAnyMenu(menus: string[]): boolean {
        if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
            return false;
        }
        const menusUser = this.userIdentity.rules.map(r =>
            r.rule.replace('READ_', '').replace('EDIT_', '').replace('WRITE_', '')
        );
        return this.userIdentity.authorities.includes('SUPER_ADMIN') || menus.some((rule: string) => menusUser.includes(rule));
    }

    hasAnyAuthority(authorities: string[]): boolean {
        if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
            return false;
        }

        return this.userIdentity.authorities.includes('SUPER_ADMIN')
            || authorities.some((authority: string) => this.userIdentity.authorities.includes(authority));
    }

    hasAuthority(authority: string): Promise<boolean> {
        if (!this.authenticated) {
            return Promise.resolve(false);
        }

        return this.identity().then(
            id => {
                return Promise.resolve(id.authorities && id.authorities.includes(authority));
            },
            () => {
                return Promise.resolve(false);
            }
        );
    }
}
